import { Component } from 'react';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import { jsx as _jsx } from "react/jsx-runtime";
class WaitUntilActionHistoryCard extends Component {
  render() {
    const {
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel
    });
  }
}
export default WaitUntilActionHistoryCard;